import { render, staticRenderFns } from "./followup.vue?vue&type=template&id=66a39582&scoped=true&"
import script from "./followup.vue?vue&type=script&lang=ts&"
export * from "./followup.vue?vue&type=script&lang=ts&"
import style0 from "./followup.vue?vue&type=style&index=0&id=66a39582&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66a39582",
  null
  
)

export default component.exports